<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-card color="transparent" flat>
      <v-toolbar color="transparent" flat>
        <v-toolbar-title class="font-weight-bold"
          >{{ $t('EPDRequiredFieldSettings') }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <!-- <v-btn outlined depressed color="primary" class="mr-2">Cancel</v-btn> -->
        <v-btn color="primary" @click="confirmDialog = true">{{ $t('save') }}</v-btn>
      </v-toolbar>
      <v-card-text class="v-card__body">
        <h3 class="black--text pb-8">
          {{ $t('modelSettings.required') }}
        </h3>

        <hr class="grey-hr" />

        <v-row class="pt-8">
          <v-col cols="6">
            <label class="input-label"
              >{{ $t('geneticsAndBreeding.selectTrait') }} <v-icon>mdi-help-circle-outline</v-icon></label
            >
            <v-select
              :items="traits"
              item-text="label"
              item-value="value"
              v-model="trait"
              outlined
              dense
              @change="getInitialDetails"
            ></v-select>

            <h3 class="black--text pb-8">{{ $t('byDefault') }}</h3>

            <v-row>
              <v-col
                cols="6"
                class="py-1"
                v-for="(item, index) in requiredFields"
                :key="index"
              >
                <v-checkbox
                  v-model="item.status"
                  :label="item.name"
                  :disabled="contemporaryGroupCount > 0"
                  color="primary"
                  hide-details
                >
                </v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <div class="bottom-banner">
          <strong>{{ $t('note') }}</strong>: {{ $t('modelSettings.note1') }}
        </div>
        <div class="note-banner" v-if="contemporaryGroupCount > 0">
          <strong>{{ $t('note') }}</strong>: {{ $t('modelSettings.note2') }}
        </div>
      </v-card-text>

      <v-dialog
        v-model="confirmDialog"
        width="500"
        @click:outside="confirmDialog = false"
        :retain-focus="false"
      >
        <v-card class="custom-card" rounded="0">
          <v-toolbar color="secondary" class="white--text" flat>
            <v-toolbar-title class="font-weight-bold">
              {{ $t('warning') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon class="white--text" @click="confirmDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-form lazy-validation autocomplete="off">
            <v-card-text class="black--text">
              <v-row>
                <v-col cols="12">
                  <div class="text-center">
                    <img src="../../assets/warning.svg" />
                  </div>
                  <div class="py-5 text-center">
                    {{ $t('modelSettings.fieldCalculation') }}
                  </div>
                </v-col>
              </v-row>
              <v-divider class="mt-5"></v-divider>
              <v-card-actions class="mt-2" style="padding-right: 0">
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2"
                  right
                  height="44"
                  width="116"
                  depressed
                  color="primary"
                  @click="confirmDialog = false"
                >
                  {{ $t('cancel') }}
                </v-btn>
                <v-btn
                  right
                  height="44"
                  width="116"
                  color="primary"
                  depressed
                  @click="updateRequiredFields"
                >
                {{ $t('proceed') }}
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import LoadingMixin from "@/mixins/LoadingMixin";
// import axios from "axios";
import {
  getEpdRequiredFieldByTrait,
  createEpdRequiredField,
  getContemporaryGroupCount,
} from "@/graphql/EPD.gql";

export default {
  name: "EPDRequiredFieldsSetting",

  data() {
    return {
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("geneticsAndBreeding.geneticsAndBreeding"),
          disabled: false,
          link: true,
          exact: true,
          to: { name: "Genetics" },
        },
        {
          text: this.$t("EPDRequiredFieldSettings"),
          disabled: true,
        },
      ],
      traits: [
        {
          label: "Birth Weight",
          value: "birthWeight",
        },
        {
          label: "Weaning Weight",
          value: "weaningWeight",
        },
        {
          label: "Yearling Weight",
          value: "yearlingWeight",
        },
        {
          label: "Carcass Weight",
          value: "carcassWeight",
        },
      ],
      trait: "birthWeight",
      requiredFields: [],
      confirmDialog: false,
      contemporaryGroupCount: 0,
    };
  },
  methods: {
    async getRequiredFields() {
      // const res = await axios.get(`/animalGenetics/epdRequiredFieldsSetting/${this.trait}`)
      this.requiredFields = this.requiredFields = [
        {
          id: "birth_year",
          name: "Birth Year",
          status: true,
        },
        {
          id: "season_of_birth",
          name: "Season of Birth",
          status: true,
        },
        {
          id: "birth_sex",
          name: "Birth Sex",
          status: false,
        },
        {
          id: "birth_weight",
          name: "Birth Weight",
          status: true,
        },
        {
          id: "primary_breed_composition",
          name: "Primary Breed Composition",
          status: true,
        },
        {
          id: "secondary_breed_composition",
          name: "Secondary Breed Composition",
          status: true,
        },
        {
          id: "conception_method",
          name: "Conception Method",
          status: true,
        },
      ];
      // this.startLoading();
      const { data } = await this.$apollo.query({
        query: getEpdRequiredFieldByTrait,
        fetchPolicy: "no-cache",
        variables: {
          traitType: this.traits.find((item) => item.value === this.trait)
            .label,
        },
      });

      this.requiredFields = data?.getEpdRequiredFieldByTrait?.requiredFields;
      // this.stopLoading();
    },

    async getContemporaryGroup() {
      const { data } = await this.$apollo.query({
        query: getContemporaryGroupCount,
        fetchPolicy: "no-cache",
        variables: {
          traitType: this.trait,
        },
      });

      this.contemporaryGroupCount =
        data?.getContemporaryGroupCount?.contempGroupCount;

      // const res = await axios.get(
      //   `animalGenetics/contemporaryGroup/${this.trait}?page=1&limit=10&searchPhrase=`
      // );
      // if (res.data.success) {
      //   this.contemporaryGroupCount = res.data.data.count;
      // } else {
      //   this.$notify({
      //     title: "Error fetching contemporaryGroup.",
      //     text: res.data.message,
      //     type: "error",
      //   });
      // }
    },
    async getInitialDetails() {
      this.getRequiredFields();
      this.getContemporaryGroup();
    },
    getFinalRequiredFields(fields) {
      return fields.map((field) => {
        const finalData = {
          id: field.id,
          name: field.name,
          status: field.status,
        };
        return finalData;
      });
    },
    async updateRequiredFields() {
      this.startLoading();
      this.$apollo
        .mutate({
          mutation: createEpdRequiredField,
          variables: {
            epdRequiredFieldInput: {
              traitType: this.traits.find((item) => item.value === this.trait)
                ?.label,
              requiredFields: this.getFinalRequiredFields(this.requiredFields),
            },
          },
        })
        .then(async (res) => {
          this.stopLoading();
          console.log(res);
          this.confirmDialog = false;
          // if (res.data.removeTask) {
          //   this.dialog = false;
          //   this.$notify({
          //     title: "TasK Deleted",
          //     text: res.message,
          //     type: "success",
          //   });
          //   this.$apollo.queries.tasks.refetch();
          // } else {
          //   this.$notify({
          //     title: "Task Not Deleted",
          //     text: res.message,
          //     type: "error",
          //   });
          // }
        })
        .catch((err) => {
          this.stopLoading();
          console.log(err);
          this.confirmDialog = false;
        });
      // const res = await axios.put(
      //   `/animalGenetics/epdRequiredFieldsSetting/${
      //     this.traits.find((item) => item.value === this.trait).label
      //   }`,
      //   {
      //     requiredFields: this.requiredFields,
      //   }
      // );
      // if (res.data.success) {
      //   this.confirmDialog = false;
      //   this.requiredFields = res.data.data.requiredFields;
      //   this.$notify({
      //     title: "Success",
      //     text: res.data.message,
      //     type: "success",
      //   });
      // } else {
      //   this.$notify({
      //     title: "Error",
      //     text: res.data.message,
      //     type: "error",
      //   });
      // }
    },
  },
  created() {
    this.getInitialDetails();
  },
  mixins: [LoadingMixin],
};
</script>
<style scoped>
.v-card__body {
  background-color: #ffffff;
  padding: 24px;
  margin: 16px;
}

.grey-hr {
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: none;
}

.input-label {
  color: #1e1e1e;
  font-size: 14px;
  margin-bottom: 8px;
  display: block;
}

.input-label i {
  font-size: 20px;
  margin-left: 8px;
}

.bottom-banner {
  margin-top: 60px;
  background-color: #fff7ec;
  border: 1px solid #ffb443;
  border-radius: 5px;
  padding: 18px 26px;
}

.note-banner {
  margin-top: 10px;
  background-color: #fff7ec;
  border: 1px solid #ffb443;
  border-radius: 5px;
  padding: 18px 26px;
}
.bottom-banner .note-banner strong {
  font-weight: 600;
  color: #1e1e1e;
}
</style>
